module.exports = __webpack_public_path__ + "static/media/remove_format.374af90e.png";